import { getNow } from "./dates.ts";

// en-US 12/19/2012
// en-GB 19/12/2012
// en-CA 2012-12-19
export function toNumericDate(date: string | Date | number, locale: string) {
    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
}

// en-US December 19, 2012
// en-GB 19 December 2012
// en-CA December 19, 2012
export function toLongDateWithYear(date: string | Date | number, locale: string) {
    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
}

export function toLongUTCDateWithYear(date: string | Date | number, locale: string) {
    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
    });
}

// en-US December 19, 2012 or December 19 (if current year)
// en-GB 19 December 2012 or 19 December (if current year)
// en-CA December 19, 2012 or December 19 (if current year)
export function toLongDate(date: string | Date | number, locale: string) {
    const parsedDate = new Date(date);

    if (parsedDate.getFullYear() === new Date(getNow()).getFullYear()) {
        return parsedDate.toLocaleDateString(locale, {
            month: "long",
            day: "numeric"
        });
    }

    return parsedDate.toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
}

// en-US December 19, 2012 at 10:00 PM
// en-GB 19 December 2012 at 22:00
// en-CA December 19, 2012 at 10:00 p.m.
export function toLongDateWithTime(date: string | Date | number, locale: string) {
    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    });
}

// en-US December 19, 2012 at 10:00 PM EST
// en-GB 19 December 2012 at 22:00 GMT+1
export function toLongDateWithTimeAndZone(date: string | Date | number, locale: string) {
    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZoneName: "short"
    });
}

// en-US Dec 19, 2012
// en-GB 19 Dec 2012
// en-CA Dec 19, 2012
export function toShortDateWithYear(date: string | Date | number, locale: string) {
    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric"
    });
}

// en-US Dec 19, 2012 or Dec 19 (if current year)
// en-GB 19 Dec 2012 or 19 Dec (if current year)
// en-CA Dec 19, 2012 or Dec 19 (if current year)
export function toShortDate(date: Date | string | number, locale: string) {
    const parsedDate = new Date(date);

    if (parsedDate.getFullYear() === new Date(getNow()).getFullYear()) {
        return parsedDate.toLocaleDateString(locale, {
            month: "short",
            day: "numeric"
        });
    }

    return parsedDate.toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric"
    });
}

// en-US Dec 19, 2012 or Dec 19 (if current year)
// en-GB 19 Dec 2012 or 19 Dec (if current year)
// en-CA Dec 19, 2012 or Dec 19 (if current year)
export function toShortUTCDate(date: Date | string | number, locale: string) {
    const parsedDate = new Date(date);

    if (parsedDate.getUTCFullYear() === new Date(getNow()).getUTCFullYear()) {
        return parsedDate.toLocaleDateString(locale, {
            month: "short",
            day: "numeric",
            timeZone: "UTC"
        });
    }

    return parsedDate.toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
    });
}

// en-US Dec 19, 2012, 22:00 or Dec 19, 22:00 (if current year)
// en-GB 19 Dec 2012, 22:00 or 19 Dec, 22:00 (if current year)
// en-CA Dec 19, 2012, 22:00 or Dec 19, 22:00 (if current year)
export function toShortDateWithTime(date: Date | string | number, locale: string) {
    const parsedDate = new Date(date);

    if (parsedDate.getFullYear() === new Date(getNow()).getFullYear()) {
        return parsedDate.toLocaleDateString(locale, {
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: false
        });
    }

    return new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    });
}
